PJQ.views.commitments.ChangeOrdersList = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.COMMITMENTS, 'commitment-change-orders-list'),
        changeOrderId: null
    },
    events: {
        'click .btn-settings': 'editSettings',
        'click .btn-add-change-order': 'newChangeOrder',
        'click .btn-view-change-order': 'viewChangeOrderClicked',
        'click .btn-delete-change-order': 'deleteChangeOrderClicked',
        'click .btn-export': 'exportChangeOrderList',
        'click .btn-pull-erp': 'pullERP',
    },
    beforeFirstRender: async function () {
        this.isFetched = false;

        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;

        if (this.collection == null) {
            this.collection = new PJQ.collections.commitments.ChangeOrders(null, {
                projectId: this.options.project.get('projectId'),
                costCodeId: this.options.costCodeId ? this.options.costCodeId : null,
                costTypeId: this.options.costTypeId ? this.options.costTypeId : null
            });
        }

        if (!this.collection.isFetched) {
            await this.collection.fetch();
        }

        this.userSettings = await PJQ.app.session.fetchCommitmentChangeOrderUserSettings();
        this.customFields = await this.options.project.fetchCommitmentChangeOrderCustomFields();
        this.erpIntegration = await PJQ.app.session.fetchERPIntegration();

        if (this.erpIntegration != null && this.erpIntegration.getSetting('syncProjects')) {
            await this.options.project.fetchERPObject();
        }

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.options.canAdd = this.options.project.hasPermission('commitmentChangeOrders.canAdd');
        this.options.canViewCommitments = this.options.project.hasPermission('commitments.canView');
        this.options.isAdmin = this.options.project.hasPermission('commitmentChangeOrders.isAdmin');
    },
    renderData: function () {
        return {
            collection: this.collection,
            isFetched: this.isFetched
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.renderView();

        PJQ.app.session.project.off('commitmentCOChanged');
        PJQ.app.session.project.on('commitmentCOChanged', function (changeOrder) {
            this.collection.add(changeOrder);
            this.render();
        }, this);

        if (this.options.changeOrderId > 0) {
            let initChangeOrder = this.collection.get(this.options.changeOrderId);
            if (initChangeOrder != null) {
                this.viewChangeOrder(initChangeOrder);
                this.options.changeOrderId = null;
            }
        }
    },
    renderERPButton: function () {
        let $erp = this.$('.erp-sync')
        if (!this.options.isAdmin || this.erpIntegration == null || !this.erpIntegration.getSetting(PJQ.constants.integrations.settings.SYNC_COMMITMENTS) || !this.options.project || !this.options.project.isERPSynced()) {
            $erp.remove();
            return;
        }

        let pullSupported = this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PULL_COMMITMENT_CHANGE_ORDERS);
        PJQ.helpers.erp.renderERPButtons($erp, {
            pushSupported: false,
            pullSupported: pullSupported
        });
    },
    pullERP: function () {
        if (this.options.project != null && this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PULL_COMMITMENT_CHANGE_ORDERS)) {
            this.erpIntegration.pullCommitmentChangeOrders(this.options.project, _.bind(function (res) {
                PJQ.notifications.notify.successNotify({
                    message: 'Commitment Change Orders successfully pulled from ERP'
                });

                this.collection.reset(res);
                this.render();
            }, this));
        }
    },
    renderView: function () {
        if (this.dataTable) {
            this.dataTable.remove();
            this.dataTable = null;
        }

        this.dataTable = this.getDataTableInstance();
    },
    getDataTableInstance: function () {
        return new PJQ.views.commitments.ChangeOrderDataTable({
            el: this.$('.change-orders-data'),
            rowId: "cid",
            data: this.collection.models,
            statusIds: this.options.statusIds,
            isAdmin: this.options.isAdmin,
            headerData: _.bind(function () {
                return {
                    project: this.options.project,
                    canAdd: this.options.canAdd,
                    isAdmin: this.options.isAdmin
                };
            }, this),
            userSettings: this.userSettings,
            canViewCommitments: this.options.canViewCommitments,
            settings: this.userSettings.getSettings(PJQ.constants.commitments.view.CHANGE_ORDERS),
            order: [[1, 'asc']],
            colReorder: {
                fixedColumnsLeft: 1,
                fixedColumnsRight: 1,
                realtime: false
            },
            columnOrderChanged: _.bind(function () {
                this.userSettings.save();
            }, this),
            onRowDoubleClick: _.bind(function (row) {
                this.viewChangeOrder(row.data());
            }, this),
            afterDataTableRender: _.bind(function () {
                if (PJQ.app.session.erpIntegration && PJQ.app.session.erpIntegration.id > 0) {
                    this.renderERPButton();
                }
            }, this),
            contextMenuOptions: {
                actions: [
                    {
                        name: 'View',
                        onClick: _.bind(function (row) {
                            this.viewChangeOrder(row.data());
                        }, this)
                    }
                ]
            }
        });
    },
    exportChangeOrderList: function () {
        PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: PJQ.app.session.project.id
            },
            {
                endpoint: 'commitmentchangeorders'
            },
            {
                endpoint: 'export'
            }
        ], [
            {
                parameter: 'timeZoneOffset',
                value: new Date().getTimezoneOffset()
            }
        ]), {isAPIv2: true});
    },
    newChangeOrder: function (e) {
        this.viewChangeOrder();
    },
    viewChangeOrderClicked: function (e) {
        let row = this.dataTable.getRow($(e.currentTarget).closest('tr'));
        this.viewChangeOrder(row.data());
    },
    viewChangeOrder: function (changeOrder) {
        let isNew = changeOrder == null
        new PJQ.views.commitments.ChangeOrderEditModal({
            model: changeOrder,
            onSave: _.bind(function (changeOrder) {
                if (isNew) {
                    this.collection.add(changeOrder);
                }
                this.renderView();
            }, this),
            onDelete: _.bind(function (changeOrder) {
                this.collection.remove(changeOrder);
                this.renderView();
            }, this)
        });
    },
    deleteChangeOrderClicked: function (e) {
        let row = this.dataTable.getRow($(e.currentTarget).closest('tr'));
        this.deleteChangeOrder(row);
    },
    deleteChangeOrder: function (row) {
        if (row != null) {
            let changeOrder = row.data();
            if (changeOrder != null) {
                new PJQ.views.modals.DeleteCancel({
                    header: "Delete Change Order",
                    body: "Are you sure you want to delete this Change Order?",
                    onDelete: _.bind(function () {
                        changeOrder.destroy({
                            success: _.bind(function () {
                                this.dataTable.removeRow(row);
                                if (typeof this.options.onDelete === 'function') {
                                    this.options.onDelete(changeOrder);
                                }
                            }, this)
                        });
                    }, this)
                });
            }
        }
    },
    editSettings: function () {
        new PJQ.views.commitments.ChangeOrderSettingsModal({
            changeOrdersView: this,
            onSave: _.bind(function () {
                this.renderView();
                PJQ.notifications.notify.successNotify({
                    message: 'Settings updated successfully'
                });
            }, this)
        });
    }
});

PJQ.views.commitments.ModalViewChangeOrders = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.COMMITMENTS, 'modal-view-change-orders'),
        maxWidth: 1000,
        isShowCloseButton: true,
        onSave: _.noop,
        isAdmin: true
    },
    events: {},
    beforeModalCreated: function () {

    },
    renderData: function () {
        return {
            model: this.model
        }
    },
    afterRender: function () {
        if (this.model != null) {
            new PJQ.views.commitments.ChangeOrdersList({
                el: this.$('.modal-body'),
                model: this.model,
                costCodeId: this.model.get('costCodeId'),
                costTypeId: this.model.get('costTypeId'),
                project: this.options.project,
                statusIds: this.options.statusIds
            })
        }
    },
});

PJQ.views.commitments.SelectCommitmentChangeOrdersModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.COMMITMENTS, 'modal-select-commitment-change-orders'),
        width: '60%',
        maxWidth: 700,
        onSave: _.noop,
        headerSubText: null
    },
    events: {
        "change .select-change-order": "selectChangeOrder",
        "click .btn-save": "save",
        "click .btn-cancel": "cancel"
    },
    beforeModalCreated: async function () {
        this.isFetched = false;
        this.options.isAdmin = PJQ.app.session.project.hasPermission('commitmentChangeOrders.isAdmin');
        this.selectedChangeOrders = [];

        if (this.collection == null) {
            this.collection = new PJQ.collections.commitments.ChangeOrders(null, {
                projectId: this.options.project.get('projectId')
            });
        }

        if (!this.collection.isFetched) {
            await this.collection.fetch();
        }

        this.isFetched = true;
        this.render();
    },
    renderData: function () {
        return {
            headerSubText: this.options.headerSubText,
            isSingleChoice: this.options.isSingleChoice
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        let data;
        if (_.size(this.options.filterStatuses) > 0) {
            data = _.filter(this.collection.models, (model) => {
                let statusId = model.get('statusId');

                if (_.isArray(this.options.filterStatuses)) {
                    return _.includes(this.options.filterStatuses, statusId);
                } else if (_.isNumber(this.options.filterStatuses)) {
                    return this.options.filterStatuses === statusId;
                }

                return false;

            });
        } else {
            data = this.collection.models;
        }

        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.cco-table'),
            data: data,
            isHideSearch: true,
            order: [],
            columns: [{
                "data": "attributes.isSelected",
                "title": "",
                "orderable": false,
                "searchable": false,
                "render": _.bind(function (data) {
                    return ('<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox" ' + (data ? 'checked' : '') + ' class="select-change-order"/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
                }, this)
            },
                {
                    "data": "attributes.number",
                    "title": "Number",
                    "orderable": true
                },
                {
                    "columnData": "attributes.contractedContact.companyName",
                    "title": "Company",
                    "titleSettings": "Contracted Company",
                    "render": _.bind(function (data, type, row) {
                        return row.get('contractedContact') ? row.get('contractedContact').companyName : 'N/A';
                    }, this)
                },
                {
                    "data": "attributes.description",
                    "title": "Description",
                    "orderable": false
                },
                {
                    "data": "attributes.amount",
                    "title": "Amount",
                    "orderable": false,
                    "className": "text-align-right",
                    "render": _.bind(function (data, type, row) {
                        return PJQ.helpers.formatHelpers.formatCurrency(data);
                    }, this)
                }],
            dom: '<"top"<"clear">>rt<"bottom"p<"clear">>'
        });
    },
    selectChangeOrder: function (e) {
        let target = $(e.currentTarget),
            changeOrder = this.dataTable.getRow(target.closest('tr')).data();

        if (this.options.isSingleChoice) {
            this.$('.select-cco').not(target).text('Select').prop('checked', false);
            if (changeOrder.get('isSelected')) {
                changeOrder.set('isSelected', false);
                this.selectedChangeOrder = null;
            } else {
                changeOrder.set('isSelected', true);
                this.selectedChangeOrder = changeOrder;
                this.collection.get(changeOrder.id);
                _.each(this.collection.models, _.bind(function (dtChangeOrder) {
                    if (changeOrder.id !== dtChangeOrder.id)
                        dtChangeOrder.set('isSelected', false);
                }, this));
            }
            this.$('.btn-save').attr('disabled', this.selectedChangeOrder == null);

            if (typeof this.options.onChangeOrderSelected === 'function') {
                this.options.onChangeOrderSelected(this.selectedChangeOrder);
            }
        } else {
            if (changeOrder.get('isSelected')) {
                target.text('Select').addClass('btn-primary').removeClass('btn-secondary');
                changeOrder.set('isSelected', false);
                this.selectedChangeOrders = _.reject(this.selectedChangeOrders, function (selChangeOrder) {
                    return selChangeOrder.id === changeOrder.id;
                });
            } else {
                target.text('Deselect').addClass('btn-secondary').removeClass('btn-primary');
                changeOrder.set('isSelected', true);
                this.selectedChangeOrders.push(changeOrder);
            }
            this.$('.btn-save').attr('disabled', this.selectedChangeOrders == null);

            if (typeof this.options.onChangeOrderSelected === 'function') {
                this.options.onChangeOrderSelected(this.selectedChangeOrders);
            }
        }
    },
    cancel: function () {
        if (this.options.onCancel) {
            this.options.onCancel();
        }
        this.removeModal();
    },
    save: function () {
        if (this.options.onSave) {
            this.options.onSave(this.selectedChangeOrder ? this.selectedChangeOrder : this.selectedChangeOrders);
            this.removeModal();
        }
    }
});